// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"03725d19","144":"70a897a8","451":"540d9afc","473":"b2cc1559","490":"24945b55","739":"0d322ef1","752":"790cc529","949":"ea06e7bb"}[chunkId] + ".chunk.js";
};